'use client'
import { useTheme } from '@payloadcms/ui'
import clsx from 'clsx'
import Image from 'next/image'
import { usePathname } from 'next/navigation'

import React from 'react'

interface Props {
  className?: string
  loading?: 'lazy' | 'eager'
  priority?: 'auto' | 'high' | 'low'
  lang?: 'en' | 'fr' | 'ar' | 'all' | undefined
}

export const Logo = (props: Props) => {
  const { loading: loadingFromProps, priority: priorityFromProps, className, lang } = props

  const loading = loadingFromProps || 'lazy'
  const priority = priorityFromProps || 'low'

  return (
    /* eslint-disable @next/next/no-img-element */
    <Image
      alt="Soukna Logo"
      width={193}
      height={34}
      loading={loading}
      fetchPriority={priority}
      decoding="async"
      className={clsx('max-w-[9.375rem] w-full h-[34px] object-cover', className)}
      src={lang === 'ar' ? '/ArabicWhiteLogo.png' : '/LatinLogo.png'}
    />
  )
}

export const BlackLogo = (props: Props) => {
  const { loading: loadingFromProps, priority: priorityFromProps, className } = props
  const path = usePathname()
  const loading = loadingFromProps || 'lazy'
  const priority = priorityFromProps || 'low'
  const { theme } = useTheme()

  return (
    /* eslint-disable @next/next/no-img-element */
    <Image
      alt="Soukna black Logo"
      width={path.includes('login') ? 193 : 28}
      height={path.includes('login') ? 34 : 28}
      // loading={loading}
      // fetchPriority={priority}
      decoding="async"
      className={clsx('', className)}
      src={
        path.includes('login')
          ? theme === 'dark'
            ? '/login/w-logo.svg'
            : '/blackLogo.svg'
          : '/icons/smallLogo.svg'
      }
    />
  )
}
